"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var restoreConversationService_1 = require("../services/restoreConversationService");
var datapoints_1 = require("./datapoints");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var Store_1 = require("owa-mail-list-store/lib/store/Store");
var actionTypes_1 = require("owa-mail-store/lib/actions/actionTypes");
var owa_service_error_1 = require("owa-service-error");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var legacy_1 = require("satcheljs/lib/legacy");
var stitch_1 = require("satcheljs/lib/legacy/stitch");
var filterConversationRowsByRestriction_1 = require("owa-mail-list-store/lib/utils/filterConversationRowsByRestriction");
var RestoreConversationActionName = 'RestoreConversation';
/**
 * Restore conversations action
 * @param rowKeys the specified rowKeys
 * @param tableViewId the table view id
 * @param state the RestoreConversationState which contains the original table view
 * @return the action response
 */
exports.default = legacy_1.select({
    originalTableView: function (conversationRowKeys, tableViewId) {
        return Store_1.default.tableViews.get(tableViewId);
    },
})(legacy_1.action(RestoreConversationActionName, datapoints_1.default.restoreConversationDatapoint)(function restoreConversations(conversationRowKeys, tableViewId, state) {
    var filteredRowKeys = filterConversationRowsByRestriction_1.default(conversationRowKeys, tableViewId, function (tableConversationRelation) { return !!tableConversationRelation; });
    var conversationIdStrings = owa_mail_list_store_1.getRowIdsFromRowKeys(filteredRowKeys, tableViewId);
    var conversationActionContexts = filteredRowKeys.map(function (rowKey) {
        return owa_mail_list_store_1.getApplyConversationActionContext(rowKey, tableViewId);
    });
    // TODO: VSO 11909: Handle undo for destructive mail actions
    var actionResponse = owa_service_error_1.handleServiceError(RestoreConversationActionName, owa_mail_strings_1.default.errorRestore, function () {
        var sourceFolderId = state.originalTableView.serverFolderId;
        // Make service request
        return restoreConversationService_1.default(conversationActionContexts, sourceFolderId);
    });
    // raise stitch to delete conversation from reading pane, but not undo because we are not in delete items when undoing
    stitch_1.raiseAction(actionTypes_1.actionNames.DeleteConversationStoreUpdate)(conversationIdStrings, state.originalTableView);
    return actionResponse;
}));
//# sourceMappingURL=restoreConversation.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/orchestration/owa-mail-triage-action/lib/actions/restoreConversation.js
// module id = 5616
// module chunks = 62